module.exports = __webpack_public_path__ + "img/Wasserfall.60c0e2d5.svg";